export default __webpack_public_path__ + "static/media/color-g.6268ad1b.webp";